import { render, staticRenderFns } from "./MinionsTable.vue?vue&type=template&id=2837a6b8&scoped=true&"
import script from "./MinionsTable.vue?vue&type=script&lang=js&"
export * from "./MinionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837a6b8",
  null
  
)

export default component.exports